import React from 'react';

import Heading from './renderers/Heading';
import Paragraph from './renderers/Paragraph';
import Link from './renderers/Link';

const ComparisonCard = ({ icon, title, description, name, url }, index) => {
  const hasIcon = !!icon;
  const iconSource = icon.url;

  return (
    <article key={index} className="md:w-1/2 px-6 mb-6 lg:mb-12">
      <div className="bg-white rounded transition-all transform duration-100 ease-in-out hover:scale-105 shadow-lg hover:shadow-2xl h-full overflow-hidden">
        <div className="p-6 pb-16 h-full relative">
          <div className="-mt-12">
            <Heading level={3} children={title} className="text-zodiac" />
          </div>

          {description && (
            <Paragraph className="text-sm">{description}</Paragraph>
          )}

          <div className="flex justify-between items-center relative z-10">
            <Link
              href={url}
              className="font-bold text-sm py-2 px-4 border border-rose rounded inline-block text-rose hover:text-cornflower bg-transparent hover:border-cornflower z-10 relative"
            >
              Learn more &#8594;
            </Link>

            {hasIcon && (
              <div className="w-16 text-rose">
                <img src={iconSource} alt={`${name} logo`} />
              </div>
            )}
          </div>

          <svg
            className="absolute bottom-0 left-0 w-full text-whisper fill-current"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
          >
            <path d="M0,192L120,208C240,224,480,256,720,234.7C960,213,1200,139,1320,101.3L1440,64L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z"></path>
          </svg>
        </div>
      </div>
    </article>
  );
};

export default ComparisonCard;
